module.exports = __webpack_public_path__ + "media/img/corporate/company_profile-3d6f09ad76b846f49d2d7ba290ee348b.png";